export default function registerCustomerPicker(Alpine) {
  Alpine.data("customerPicker", ({ endpoint, initialId, initialLabel }) => ({
    endpoint,
    query: initialLabel || "",
    selectedId: initialId || "",
    selectedLabel: initialLabel || "",
    results: [],
    open: false,
    loading: false,
    focusedIndex: -1,
    _searchSeq: 0,
    _debounceTimer: null,
    // Set when the component writes `query` itself. Selecting or clearing a
    // customer changes the query text, and the watcher on `query` would then
    // fire another search — reopening the dropdown the user just dismissed and
    // leaving a request in flight while the surrounding form is submitted.
    _suppressSearch: false,

    debouncedSearch() {
      clearTimeout(this._debounceTimer);
      if (this._suppressSearch) {
        this._suppressSearch = false;
        return;
      }
      this._debounceTimer = setTimeout(() => this.search(), 180);
    },

    async search() {
      const seq = ++this._searchSeq;
      this.loading = true;
      try {
        const separator = this.endpoint.includes("?") ? "&" : "?";
        const url = `${this.endpoint}${separator}q=${encodeURIComponent(this.query || "")}`;
        const resp = await fetch(url, { headers: { Accept: "application/json" } });
        if (!resp.ok) {
          this.results = [];
          return;
        }
        const data = await resp.json();
        // Drop stale responses if a newer search has started.
        if (seq !== this._searchSeq) return;
        this.results = data;
        this.focusedIndex = data.length > 0 ? 0 : -1;
        this.open = true;
      } finally {
        if (seq === this._searchSeq) this.loading = false;
      }
    },

    select(c) {
      this.selectedId = c.id;
      this.selectedLabel = c.name;
      this._suppressSearch = this.query !== c.name;
      this.query = c.name;
      this.results = [];
      this.open = false;
      this.focusedIndex = -1;
      this.$dispatch("customer-picker:changed", { id: c.id, name: c.name });
    },

    clear() {
      this.selectedId = "";
      this.selectedLabel = "";
      this._suppressSearch = this.query !== "";
      this.query = "";
      this.results = [];
      this.open = false;
      this.$dispatch("customer-picker:changed", { id: "", name: "" });
    },

    moveFocus(delta) {
      if (!this.open) {
        this.open = true;
        if (this.results.length === 0) this.search();
        return;
      }
      if (this.results.length === 0) return;
      this.focusedIndex = (this.focusedIndex + delta + this.results.length) % this.results.length;
    },

    selectFocused() {
      const c = this.results[this.focusedIndex];
      if (c) this.select(c);
    }
  }));
}
